import type { DefaultMessagesKeys } from '@src/i18n/useTranslate';

const placeholderKeys: { [rule: string]: DefaultMessagesKeys } = {
  phone_format: 'checkout_formInputPhonePlaceholder',
  email: 'checkout_formInputEmailPlaceholder',
  cpf_format: 'checkout_formInputCpfPlaceholder',
};

/**
 * The message key of the placeholder the validation rules ask for, or `null` when they ask for none.
 * Sellers pair rules (`numeric` + `cpf_format`), so the first rule with a placeholder wins, not the first rule.
 */
export const resolveFormInputPlaceholder = (validationRules: string[] | null): DefaultMessagesKeys | null => {
  const rule = (validationRules ?? []).find((candidate) => candidate in placeholderKeys);

  return (rule && placeholderKeys[rule]) || null;
};
